module.exports = __webpack_public_path__ + "static/img/Corregir_TEST.9c411da7.png";